const dataFormations = [
    {
        id: 1,
        title: "Formation Symfony 5",
        date: "01/01/2021 - 31/11/2020",
        location: "A distance",
    },
    {
        id: 2,
        title: "Formation Integrateur web",
        date: "01/09/2019 - 31/12/2020",
        location: "A distance",
    },
    {
        id: 3,
        title: "BTS Productique Mécanique Option Usinage",
        date: "01/09/2000 - 31/07/2002",
        location: "Lycée Jehan beauce",
    },
]
export default dataFormations